(function () {
  const R = (window.RB.Rift = window.RB.Rift || {});

  const BASE = [[300, -60], [262, 150], [286, 300], [232, 470], [258, 620], [206, 800], [228, 960]];
  const FADE = [0.5, 0.72, 1];
  const LIT = "#homescreen .mspane, #homescreen .hmplate, #homescreen .hmbf";
  const POOL = 44;
  const WIDE_EVERY = 6;
  const SEAM_EVERY = 3;
  const BURST = { lead: 150, run: 620, tail: 380 };
  const SPAN = BURST.lead + BURST.run + BURST.tail;

  const S = {
    svg: null, base: null, live: null, wide: null, mid: null, fil: null,
    comet: null, sparks: null, spark: [], embers: [],
    domain: "none", ink: [240, 196, 106], raf: 0, t0: 0, prev: 0, frame: 0,
    lit: [], ctm: null, pts: [], sp: [], armed: null, fired: null, emitDue: 0, reduce: false,
  };

  function hash(i, n) {
    const x = Math.sin(i * 12.9898 + n * 78.233) * 43758.5453;
    return (x - Math.floor(x)) * 2 - 1;
  }

  function flick(i, t, rate) {
    const p = t * rate, a = Math.floor(p), f = p - a;
    const s = f * f * (3 - 2 * f);
    return hash(i, a) + (hash(i, a + 1) - hash(i, a)) * s;
  }

  const MOODS = {
    none: {
      shape: function (i, t, p) {
        return [p[0] + Math.sin(t * 0.68 + i * 1.7) * 3.2, p[1] + Math.cos(t * 0.51 + i * 2.3) * 2.4];
      },
      width: function (t) { const b = 1 + Math.sin(t * 0.74) * 0.04; return [b, b, b]; },
      fade: function () { return FADE; },
      k: function (t) { return 0.5 + Math.sin(t * 0.74) * 0.06; },
      ember: 0,
      pace: function (u) { return u * u * (3 - 2 * u); },
    },
    fury: {
      shape: function (i, t, p) {
        const side = i % 2 ? -1 : 1;
        const draft = Math.sin(t * 2.02 + i * 1.31) * 5.4 * side;
        const burn = flick(i, t, 9) * 3.6 + flick(i + 40, t, 21) * 1.4;
        return [p[0] + draft + burn, p[1] + flick(i + 9, t, 7) * 4.2];
      },
      width: function (t) {
        const f = flick(0, t, 13) * 0.17 + Math.sin(t * 17.3) * 0.05;
        return [1 + f * 0.3, 1 + f, 1 + f * 1.6];
      },
      fade: function (t) {
        return [FADE[0] * (0.86 + flick(3, t, 6) * 0.14), FADE[1] * (0.87 + flick(5, t, 15) * 0.13), 1];
      },
      k: function (t) { return 0.64 + flick(7, t, 11) * 0.28; },
      ember: 7,
      pace: function (u) { return Math.pow(u, 1.35); },
    },
  };

  function mood() { return MOODS[S.domain] || MOODS.none; }

  function pointAt(u) {
    const p = S.pts, n = p.length - 1;
    const f = Math.max(0, Math.min(1, u)) * n;
    const i = Math.min(n - 1, Math.floor(f)), g = f - i;
    return [p[i][0] + (p[i + 1][0] - p[i][0]) * g, p[i][1] + (p[i + 1][1] - p[i][1]) * g];
  }

  function toPath(p) {
    let d = "M" + p[0][0].toFixed(1) + " " + p[0][1].toFixed(1);
    for (let i = 1; i < p.length; i++) d += " L" + p[i][0].toFixed(1) + " " + p[i][1].toFixed(1);
    return d;
  }

  function xAtY(sp, y) {
    for (let i = 1; i < sp.length; i++) {
      const a = sp[i - 1], b = sp[i];
      if ((y >= a[1] && y <= b[1]) || (y >= b[1] && y <= a[1])) {
        return a[0] + (b[0] - a[0]) * ((y - a[1]) / ((b[1] - a[1]) || 1));
      }
    }
    return null;
  }

  function falloff(px) {
    const a = Math.abs(px - 50);
    if (a <= 70) return 1;
    if (a >= 132) return 0;
    return 1 - (a - 70) / 62;
  }

  function syncLit() {
    if (!S.svg) return;
    S.ctm = S.svg.getScreenCTM();
    S.lit = [];
    const found = document.querySelectorAll(LIT);
    for (const e of found) S.lit.push({ e: e, r: e.getBoundingClientRect(), x: -999, a: -1 });
  }

  function seam(k, headY, energy) {
    const m = S.ctm;
    if (!m) return;
    const sp = S.sp;
    for (let i = 0; i < S.pts.length; i++) {
      const p = S.pts[i];
      sp[i] = [m.a * p[0] + m.c * p[1] + m.e, m.b * p[0] + m.d * p[1] + m.f];
    }
    const ink = S.ink;
    for (const L of S.lit) {
      const r = L.r;
      if (!r.width) continue;
      const cy = r.top + r.height / 2;
      const x = xAtY(sp, cy);
      const px = x === null ? -999 : (x - r.left) / r.width * 100;
      const near = falloff(px);
      let a = k * near;
      if (energy > 0 && headY !== null) {
        const dy = (cy - headY) / 210;
        a += energy * 1.15 * Math.exp(-dy * dy) * (0.22 + 0.78 * near);
      }
      a = Math.max(0, Math.min(1, a));
      if (Math.abs(px - L.x) > 0.25) {
        L.x = px;
        L.e.style.setProperty("--seamx", px.toFixed(2) + "%");
      }
      if (Math.abs(a - L.a) > 0.008) {
        L.a = a;
        const rgb = ink[0] + "," + ink[1] + "," + ink[2] + ",";
        L.e.style.setProperty("--seamc", "rgba(" + rgb + (a * 0.85).toFixed(3) + ")");
        L.e.style.setProperty("--seamd", "rgba(" + rgb + (a * 0.15).toFixed(3) + ")");
      }
    }
  }

  function spawnEmber(t, u, spread, heat) {
    if (S.embers.length >= POOL) return;
    const p = pointAt(u);
    S.embers.push({
      x: p[0] + (Math.random() - 0.5) * spread, y: p[1] + (Math.random() - 0.5) * 40,
      vx: (Math.random() - 0.5) * 26, vy: -34 - Math.random() * 62 * heat,
      r: 0.9 + Math.random() * 2.1, born: t, life: 1.2 + Math.random() * 1.2, seed: Math.random() * 9,
    });
  }

  function embers(t, dt, m, energy) {
    const rate = m.ember * (1 + energy * 5);
    if (rate > 0) {
      S.emitDue += dt * rate;
      while (S.emitDue >= 1) { S.emitDue -= 1; spawnEmber(t, Math.random(), 22, 1 + energy); }
    }
    const keep = [];
    for (const e of S.embers) {
      const age = t - e.born;
      if (age >= e.life) continue;
      e.vy *= 0.992;
      e.x += (e.vx + Math.sin(t * 2.6 + e.seed) * 16) * dt;
      e.y += e.vy * dt;
      keep.push(e);
    }
    S.embers = keep;
    for (let i = 0; i < S.spark.length; i++) {
      const c = S.spark[i], e = S.embers[i];
      if (!e) { if (c.getAttribute("r") !== "0") c.setAttribute("r", "0"); continue; }
      const f = 1 - (t - e.born) / e.life;
      c.setAttribute("cx", e.x.toFixed(1));
      c.setAttribute("cy", e.y.toFixed(1));
      c.setAttribute("r", (e.r * (0.4 + f * 0.6)).toFixed(2));
      c.setAttribute("opacity", (f * f * 0.9).toFixed(3));
    }
  }

  function draw(t, dt) {
    const m = mood();
    for (let i = 0; i < BASE.length; i++) S.pts[i] = m.shape(i, t, BASE[i]);
    const d = toPath(S.pts);
    if (S.live) S.live.setAttribute("d", d);
    if (S.base && S.frame % WIDE_EVERY === 0) S.base.setAttribute("d", d);

    const w = m.width(t), f = m.fade(t);
    if (S.wide) S.wide.setAttribute("opacity", f[0].toFixed(3));
    if (S.mid) {
      S.mid.setAttribute("opacity", f[1].toFixed(3));
      S.mid.setAttribute("stroke-width", (9 * w[1]).toFixed(2));
    }
    if (S.fil) S.fil.setAttribute("stroke-width", (1.6 * w[2]).toFixed(2));

    let energy = 0, headY = null;
    if (S.fired !== null) {
      const age = t * 1000 - S.fired;
      if (age >= SPAN) { S.fired = null; if (S.comet) S.comet.setAttribute("opacity", "0"); }
      else {
        const u = Math.max(0, Math.min(1, (age - BURST.lead) / BURST.run));
        const h = m.pace(u);
        energy = age < BURST.lead ? age / BURST.lead
          : age < BURST.lead + BURST.run ? 1 : 1 - (age - BURST.lead - BURST.run) / BURST.tail;
        const head = pointAt(h);
        if (S.ctm) headY = S.ctm.b * head[0] + S.ctm.d * head[1] + S.ctm.f;
        if (S.comet) {
          const on = age > BURST.lead && u < 1;
          S.comet.setAttribute("opacity", on ? (Math.sin(Math.PI * Math.min(1, u * 1.15)) * 0.95).toFixed(3) : "0");
          S.comet.setAttribute("stroke-dashoffset", (70 - h * 1070).toFixed(1));
        }
        if (age > BURST.lead && u < 1) for (let i = 0; i < 2; i++) spawnEmber(t, h, 30, 1.8);
      }
    }

    embers(t, dt, m, energy);
    if (S.frame % SEAM_EVERY === 0 || energy > 0) seam(m.k(t), headY, energy);
  }

  function tick(now) {
    if (!S.svg || !S.svg.isConnected) { R.stop(); return; }
    S.raf = requestAnimationFrame(tick);
    if (document.hidden) { S.prev = now; return; }
    if (!S.t0) S.t0 = now;
    const t = (now - S.t0) / 1000;
    const dt = Math.min(0.05, (now - (S.prev || now)) / 1000);
    S.prev = now;
    S.frame++;
    draw(t, dt);
  }

  function flash(x, y) {
    const host = document.getElementById("homescreen");
    if (!host) return;
    const f = document.createElement("div");
    f.className = "hmflash";
    f.style.setProperty("--fx-x", x + "px");
    f.style.setProperty("--fx-y", y + "px");
    host.appendChild(f);
    f.animate(
      [{ transform: "scale(.18)", opacity: 0.62 }, { transform: "scale(2.3)", opacity: 0 }],
      { duration: 640, easing: "cubic-bezier(.15,.75,.3,1)", fill: "forwards" }
    );
    setTimeout(function () { f.remove(); }, 700);
  }

  R.burst = function (el, quiet) {
    if (S.reduce || !S.svg || S.fired !== null) return;
    S.fired = S.t0 ? performance.now() - S.t0 : 0;
    if (quiet) return;
    const r = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    flash(r ? r.left + r.width / 2 : 0, r ? r.top + r.height / 2 : 0);
  };

  R.arm = function (domain, el) {
    const r = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    S.armed = { domain: domain, x: r ? r.left + r.width / 2 : 0, y: r ? r.top + r.height / 2 : 0 };
  };

  function rgb(hex) {
    const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(String(hex || ""));
    return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
  }

  R.mount = function (domain, accent) {
    const svg = document.querySelector("#homescreen .hmkeyart svg");
    if (!svg) return R.stop();
    S.svg = svg;
    S.domain = MOODS[domain] ? domain : "none";
    S.ink = rgb(accent) || S.ink;
    S.base = svg.querySelector("#hmriftbase");
    S.live = svg.querySelector("#hmriftlive");
    S.wide = svg.querySelector(".hmriftwide");
    S.mid = svg.querySelector(".hmriftmid");
    S.fil = svg.querySelector(".hmriftfil");
    S.comet = svg.querySelector(".hmcomet");
    S.sparks = svg.querySelector(".hmembers");
    S.spark = [];
    if (S.sparks) {
      S.sparks.textContent = "";
      for (let i = 0; i < POOL; i++) {
        const c = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        c.setAttribute("r", "0");
        S.sparks.appendChild(c);
        S.spark.push(c);
      }
    }
    S.reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    syncLit();
    if (!S.bound) {
      S.bound = function () { syncLit(); };
      window.addEventListener("resize", S.bound);
      document.addEventListener("scroll", S.bound, true);
    }
    const armed = S.armed;
    S.armed = null;
    if (S.reduce) {
      S.embers = [];
      S.frame = 0;
      draw(0, 0);
      return;
    }
    if (armed) {
      S.fired = S.t0 ? performance.now() - S.t0 : 0;
      flash(armed.x, armed.y);
    }
    if (!S.raf) S.raf = requestAnimationFrame(tick);
  };

  R.stop = function () {
    if (S.raf) cancelAnimationFrame(S.raf);
    S.raf = 0;
    S.svg = null;
    S.embers = [];
    S.lit = [];
    if (S.bound) {
      window.removeEventListener("resize", S.bound);
      document.removeEventListener("scroll", S.bound, true);
      S.bound = null;
    }
  };
})();
